import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined'
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined'
import { blue, green, yellow, common } from '@mui/material/colors'

import { ReactComponent as CollectionIcon } from 'assets/service-action-types/CollectionIcon.svg'
import { ReactComponent as ConciergeIcon } from 'assets/service-action-types/ConciergeIcon.svg'
import { ReactComponent as DeliveryIcon } from 'assets/service-action-types/DeliveryIcon.svg'
import { ReactComponent as DropIcon } from 'assets/service-action-types/DropIcon.svg'
import { ReactComponent as DryRunIcon } from 'assets/service-action-types/DryRunIcon.svg'
import { ReactComponent as DumpReturnIcon } from 'assets/service-action-types/DumpReturnIcon.svg'
import { ReactComponent as FinalIcon } from 'assets/service-action-types/FinalIcon.svg'
import { ReactComponent as LiveLoadIcon } from 'assets/service-action-types/LiveLoadIcon.svg'
import { ReactComponent as RentalIcon } from 'assets/service-action-types/RentalIcon.svg'
import { ReactComponent as RepositionIcon } from 'assets/service-action-types/RepositionIcon.svg'
import { ReactComponent as SwapIcon } from 'assets/service-action-types/SwapIcon.svg'
import { ReactComponent as VacationIcon } from 'assets/services/hold/VacationIcon.svg'

export const WORK_ORDER_DOWNLOAD_PDF_KEY = 'workOrderDownloadPDF'

export const WORK_ORDER_PDF_FILTER = {
  type: 'pdf',
  searchFilters: [{ operation: 'EXIST_IN', columnValue: '', columnName: 'id' }],
  fileName: 'Work-Order',
  isDownload: true,
  buffer: true,
  urlToMapWith: WORK_ORDER_DOWNLOAD_PDF_KEY,
}

/**
 * Background colors for work order status indicators
 */
/* eslint-disable no-restricted-syntax */
export const WORK_ORDER_STATUS_COLORS = {
  Scheduled: '#F5F5F5',
  InProgress: '#BBDEFB',
  Serviced: '#C8E6C9',
  Skipped: '#FFECB3',
  Canceled: '#FFCDD2',
  VacationHold: '#D1C4E9',
  Hold: '#D1C4E9',
  Suspended: '#E57373',
}
/* eslint-enable no-restricted-syntax */

/**
 * Icons for work order status indicators
 */
export const WORK_ORDER_STATUS_ICONS = {
  Scheduled: EventAvailableIcon,
  Serviced: CheckOutlinedIcon,
  Skipped: FastForwardOutlinedIcon,
  InProgress: PlayCircleOutlineOutlinedIcon,
  Canceled: ClearIcon,
  VacationHold: VacationIcon,
  Hold: VacationIcon,
  Suspended: DeleteForeverOutlinedIcon,
}

/**
 * Maps service action type names to their SVG icon components
 */
export const SERVICE_ACTION_TYPE_TO_SVG = {
  SWAP: SwapIcon,
  DELIVERY: DeliveryIcon,
  'DUMP & RETURN': DumpReturnIcon,
  DROP: DropIcon,
  'LIVE LOAD': LiveLoadIcon,
  REPOSITION: RepositionIcon,
  FINAL: FinalIcon,
  COLLECTION: CollectionIcon,
  RENTAL: RentalIcon,
  CONCIERGE: ConciergeIcon,
  'DRY RUN': DryRunIcon,
}

/**
 * Recurrence type to heatmap value mapping for calendar display
 */
export const RECURRENCE_TO_HEATMAP_VALUE = {
  RECURRING: 1,
  ON_REQUEST: 2,
  SELECTED: 4,
  EMPTY: 0,
  MIXED: 3,
}

/**
 * Heatmap value to recurrence metadata mapping
 */
export const HEATMAP_VALUE_TO_RECURRENCE = {
  [RECURRENCE_TO_HEATMAP_VALUE.EMPTY]: {
    recurrence: 'Empty',
    color: common.white,
  },
  [RECURRENCE_TO_HEATMAP_VALUE.RECURRING]: {
    recurrence: 'Recurring',
    color: blue[100],
  },
  [RECURRENCE_TO_HEATMAP_VALUE.ON_REQUEST]: {
    recurrence: 'On Request',
    color: yellow[100],
  },
  [RECURRENCE_TO_HEATMAP_VALUE.SELECTED]: {
    recurrence: 'Selected',
    color: common.black,
  },
  [RECURRENCE_TO_HEATMAP_VALUE.MIXED]: {
    recurrence: 'Mixed',
    color: green[100],
  },
}
